import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import HBox from '../HBox';
import * as Luxon from 'luxon';
import React from 'react';

const weekdays = [
  T('SUN'),
  T('MON'),
  T('TUE'),
  T('WED'),
  T('THU'),
  T('FRI'),
  T('SAT')
];

export default function WeekHeader(props) {
  return (
    <HBox {...ex('WeekHeader', props)}>
      {weekdays.map((weekday, index) => (
        <div key={index}>
          {weekday}
        </div>
      ))}
    </HBox>
  );
}
